var items = {
  "block.minecraft.air": "weðrę",
  "block.minecraft.stone": "stie",
  "block.minecraft.granite": "koppustie",
  "block.minecraft.polished_granite": "pulirað granit",
  "block.minecraft.diorite": "diroit",
  "block.minecraft.polished_diorite": "polirað dorit",
  "block.minecraft.andesite": "andesit",
  "block.minecraft.polished_andesite": "polirað andesit",
  "block.minecraft.grass_block": "grasblokk",
  "block.minecraft.dirt": "muld",
  "block.minecraft.coarse_dirt": "russlun muld",
  "block.minecraft.podzol": "podzol",
  "block.minecraft.crimson_nylium": "karmosinnylium",
  "block.minecraft.warped_nylium": "förvrängd nylium",
  "block.minecraft.cobblestone": "gatustie",
  "block.minecraft.oak_planks": "iekplaunkur",
  "block.minecraft.spruce_planks": "grą̊plaunkur",
  "block.minecraft.birch_planks": "byörkplaunkur",
  "block.minecraft.jungle_planks": "djunggelplaunkur",
  "block.minecraft.acacia_planks": "akasiaplaunkur",
  "block.minecraft.dark_oak_planks": "mörkiekplaunkur",
  "block.minecraft.crimson_planks": "mörkroð plankur",
  "block.minecraft.warped_planks": "fevrängd plaunkur",
  "block.minecraft.oak_sapling": "iekplemta",
  "block.minecraft.spruce_sapling": "grǫplemta",
  "block.minecraft.birch_sapling": "byörkplemta",
  "block.minecraft.jungle_sapling": "djunggelplemta",
  "block.minecraft.acacia_sapling": "acasiaplemta",
  "block.minecraft.dark_oak_sapling": "mörkiekplemta",
  "block.minecraft.bedrock": "bjärggrund",
  "block.minecraft.sand": "sandn",
  "block.minecraft.red_sand": "roðsandn",
  "block.minecraft.gravel": "gruseð",
  "block.minecraft.gold_ore": "gullåðer",
  "block.minecraft.iron_ore": "iennmalmsåðer",
  "block.minecraft.coal_ore": "kuolmalmsåðer",
  "block.minecraft.nether_gold_ore": "nethergullåðer",
  "block.minecraft.oak_log": "iekkabb",
  "block.minecraft.spruce_log": "grǫkabb",
  "block.minecraft.birch_log": "byörkkabb",
  "block.minecraft.jungle_log": "junggelkabb",
  "block.minecraft.acacia_log": "akasiakabb",
  "block.minecraft.dark_oak_log": "mörkiekkabb",
  "block.minecraft.crimson_stem": "karmosinstam",
  "block.minecraft.warped_stem": "fervrängd stam",
  "block.minecraft.stripped_oak_log": "barkað iekkabb",
  "block.minecraft.stripped_spruce_log": "barkað grǫkabb",
  "block.minecraft.stripped_birch_log": "barkað byörkkabb",
  "block.minecraft.stripped_jungle_log": "barkað junggelkabb",
  "block.minecraft.stripped_acacia_log": "barkað akasiakabb",
  "block.minecraft.stripped_dark_oak_log": "barkað mörkiekkabb",
  "block.minecraft.stripped_crimson_stem": "åvbarkað karmosinstam",
  "block.minecraft.stripped_warped_stem": "åvbarkað fevränggd stam",
  "block.minecraft.stripped_oak_wood": "barkað iekwiðn",
  "block.minecraft.stripped_spruce_wood": "barkað grǫwiðn",
  "block.minecraft.stripped_birch_wood": "barkað byörkwiðn",
  "block.minecraft.stripped_jungle_wood": "barkað junggelwiðn",
  "block.minecraft.stripped_acacia_wood": "barkað akasiawiðn",
  "block.minecraft.stripped_dark_oak_wood": "barkað mörkiekwiðn",
  "block.minecraft.stripped_crimson_hyphae": "åvbarkaðer karmosinhyfer",
  "block.minecraft.stripped_warped_hyphae": "åvbarkað fevränggd yf",
  "block.minecraft.oak_wood": "iekwiðn",
  "block.minecraft.spruce_wood": "grǫwiðn",
  "block.minecraft.birch_wood": "byörkwiðn",
  "block.minecraft.jungle_wood": "junggelwiðn",
  "block.minecraft.acacia_wood": "acasiawiðn",
  "block.minecraft.dark_oak_wood": "mörkiekwiðn",
  "block.minecraft.crimson_hyphae": "karmosinyfer",
  "block.minecraft.warped_hyphae": "fevrängd yfer",
  "block.minecraft.oak_leaves": "ieklov",
  "block.minecraft.spruce_leaves": "grǫbårnǫler",
  "block.minecraft.birch_leaves": "byörklov",
  "block.minecraft.jungle_leaves": "junggellov",
  "block.minecraft.acacia_leaves": "akasialov",
  "block.minecraft.dark_oak_leaves": "mörkieklov",
  "block.minecraft.sponge": "twåsopp",
  "block.minecraft.wet_sponge": "wåt twåsopp",
  "block.minecraft.glass": "glas",
  "block.minecraft.lapis_ore": "lapis lazuli åðer",
  "block.minecraft.lapis_block": "lapis lazuli blokk",
  "block.minecraft.dispenser": "autdieler",
  "block.minecraft.sandstone": "sandstie",
  "block.minecraft.chiseled_sandstone": "mejslað sandstie",
  "block.minecraft.cut_sandstone": "klipptsandstie",
  "block.minecraft.note_block": "meddielendblokk",
  "block.minecraft.powered_rail": "rels min kraft",
  "block.minecraft.detector_rail": "rels min detektor",
  "block.minecraft.sticky_piston": "kliemun kolv",
  "block.minecraft.cobweb": "dyörgnęt",
  "block.minecraft.grass": "gras",
  "block.minecraft.fern": "uormbunk",
  "block.minecraft.dead_bush": "doð buoske",
  "block.minecraft.seagrass": "sjugras",
  "block.minecraft.sea_pickle": "sjugurka",
  "block.minecraft.piston": "kolv",
  "block.minecraft.white_wool": "wait ull",
  "block.minecraft.orange_wool": "guolroð ull",
  "block.minecraft.magenta_wool": "liuoslila ull",
  "block.minecraft.light_blue_wool": "liuosblå ull",
  "block.minecraft.yellow_wool": "guol ull",
  "block.minecraft.lime_wool": "limegryön ull",
  "block.minecraft.pink_wool": "rosa ull",
  "block.minecraft.gray_wool": "grå ull",
  "block.minecraft.light_gray_wool": "liuosgrå ull",
  "block.minecraft.cyan_wool": "syanfergað ull",
  "block.minecraft.purple_wool": "lila ull",
  "block.minecraft.blue_wool": "blå ull",
  "block.minecraft.brown_wool": "brun ull",
  "block.minecraft.green_wool": "gryön ull",
  "block.minecraft.red_wool": "roð ull",
  "block.minecraft.black_wool": "swart ull",
  "block.minecraft.dandelion": "smyörbljomm",
  "block.minecraft.poppy": "wallmuo",
  "block.minecraft.blue_orchid": "blå uortjiði",
  "block.minecraft.allium": "graslok",
  "block.minecraft.azure_bluet": "poslinsbliuomme",
  "block.minecraft.red_tulip": "roðtulpan",
  "block.minecraft.orange_tulip": "guolroð tulpan",
  "block.minecraft.white_tulip": "waittulpan",
  "block.minecraft.pink_tulip": "rosatulpan",
  "block.minecraft.oxeye_daisy": "waitkull",
  "block.minecraft.cornflower": "rugbljomm",
  "block.minecraft.lily_of_the_valley": "bukkblaðsbljomm",
  "block.minecraft.wither_rose": "wissnaðruos",
  "block.minecraft.brown_mushroom": "brunsopp",
  "block.minecraft.red_mushroom": "roðsopp",
  "block.minecraft.crimson_fungus": "karmosinsopp",
  "block.minecraft.warped_fungus": "fevrängd sopp",
  "block.minecraft.crimson_roots": "karmosinruotur",
  "block.minecraft.warped_roots": "fervrängd ruotur",
  "block.minecraft.nether_sprouts": "nethernylaðir",
  "block.minecraft.weeping_vines": "druppend kleðerwekst",
  "block.minecraft.twisting_vines": "rwaiðend kleðerwekst",
  "block.minecraft.sugar_cane": "sokkerrör",
  "block.minecraft.kelp": "alg",
  "block.minecraft.bamboo": "bambu",
  "block.minecraft.gold_block": "gullblokk",
  "block.minecraft.iron_block": "iennblokk",
  "block.minecraft.oak_slab": "iekstjiv",
  "block.minecraft.spruce_slab": "gråstjiv",
  "block.minecraft.birch_slab": "byörkstjiv",
  "block.minecraft.jungle_slab": "junggelstjiv",
  "block.minecraft.acacia_slab": "akasiastjiv",
  "block.minecraft.dark_oak_slab": "mörkiekstjiv",
  "block.minecraft.crimson_slab": "mörkroð stjiva",
  "block.minecraft.warped_slab": "fevrängd stjiva",
  "block.minecraft.stone_slab": "stiestjiv",
  "block.minecraft.smooth_stone_slab": "blotstiestjiv",
  "block.minecraft.sandstone_slab": "sandstiestjiv",
  "block.minecraft.cut_sandstone_slab": "klippt sandstiestjiv",
  "block.minecraft.petrified_oak_slab": "ferstienaðiekstjiv",
  "block.minecraft.cobblestone_slab": "gatusįestjiv",
  "block.minecraft.brick_slab": "tigelstjiv",
  "block.minecraft.stone_brick_slab": "stietigelstjiv",
  "block.minecraft.nether_brick_slab": "nethertigelstjiv",
  "block.minecraft.quartz_slab": "kwartsstjiv",
  "block.minecraft.red_sandstone_slab": "roðsandstiestiv",
  "block.minecraft.cut_red_sandstone_slab": "klipptroðsandstiestjiv",
  "block.minecraft.purpur_slab": "purpurstjiv",
  "block.minecraft.prismarine_slab": "prismarinstjiv",
  "block.minecraft.prismarine_brick_slab": "prismarintigelstjiv",
  "block.minecraft.dark_prismarine_slab": "mörk prismarinstjiv",
  "block.minecraft.smooth_quartz": "blot kwartsstjiv",
  "block.minecraft.smooth_red_sandstone": "blotroðsandstie",
  "block.minecraft.smooth_sandstone": "blotsandstie",
  "block.minecraft.smooth_stone": "blotstie",
  "block.minecraft.bricks": "tigelstiener",
  "block.minecraft.tnt": "dynamit",
  "block.minecraft.bookshelf": "buokill",
  "block.minecraft.mossy_cobblestone": "muossun gatustie",
  "block.minecraft.obsidian": "obsiðan",
  "block.minecraft.torch": "stikkliuos",
  "block.minecraft.end_rod": "slutkevil",
  "block.minecraft.chorus_plant": "körplemt",
  "block.minecraft.chorus_flower": "körbljomme",
  "block.minecraft.purpur_block": "purpurblokk",
  "block.minecraft.purpur_pillar": "purpurpiler",
  "block.minecraft.purpur_stairs": "purpurtrampur",
  "block.minecraft.spawner": "block fer te djärå ymse",
  "block.minecraft.oak_stairs": "iektrampur",
  "block.minecraft.chest": "tjista",
  "block.minecraft.diamond_ore": "diamantåder",
  "block.minecraft.diamond_block": "diamantblokk",
  "block.minecraft.crafting_table": "arbietsbainkk",
  "block.minecraft.farmland": "åkerjuord",
  "block.minecraft.furnace": "smeltungen",
  "block.minecraft.ladder": "stitji",
  "block.minecraft.rail": "rels",
  "block.minecraft.cobblestone_stairs": "gatustįetrampur",
  "block.minecraft.lever": "lunna",
  "block.minecraft.stone_pressure_plate": "stįepressplatt",
  "block.minecraft.oak_pressure_plate": "iekpressplatt",
  "block.minecraft.spruce_pressure_plate": "grǫpressplant",
  "block.minecraft.birch_pressure_plate": "byörkpressplatt",
  "block.minecraft.jungle_pressure_plate": "junggelpressplatt",
  "block.minecraft.acacia_pressure_plate": "akasiapressplatt",
  "block.minecraft.dark_oak_pressure_plate": "mörkiekpressplatt",
  "block.minecraft.crimson_pressure_plate": "mörkroð trykkstjiv",
  "block.minecraft.warped_pressure_plate": "fevrängd trykkstjiv",
  "block.minecraft.polished_blackstone_pressure_plate": "poilirað trykkplatt ov swartstien",
  "block.minecraft.redstone_ore": "redstoneåðer",
  "block.minecraft.redstone_torch": "redstonestikkliuos",
  "block.minecraft.snow": "sniųo",
  "block.minecraft.ice": "aisn",
  "block.minecraft.snow_block": "sniųoblokk",
  "block.minecraft.cactus": "kaktus",
  "block.minecraft.clay": "liera",
  "block.minecraft.jukebox": "musiklåð",
  "block.minecraft.oak_fence": "iekstakiet",
  "block.minecraft.spruce_fence": "grǫstakiet",
  "block.minecraft.birch_fence": "byörkstakiet",
  "block.minecraft.jungle_fence": "junggelstakiet",
  "block.minecraft.acacia_fence": "akasiastakiet",
  "block.minecraft.dark_oak_fence": "mörkiekstakiet",
  "block.minecraft.crimson_fence": "mörkrott stakiet",
  "block.minecraft.warped_fence": "fevrängt stakiet",
  "block.minecraft.pumpkin": "pumpa",
  "block.minecraft.carved_pumpkin": "skurin pumpa",
  "block.minecraft.netherrack": "netherrack",
  "block.minecraft.soul_sand": "själsand",
  "block.minecraft.soul_soil": "själsmulld",
  "block.minecraft.basalt": "basalt",
  "block.minecraft.polished_basalt": "polirað basalt",
  "block.minecraft.soul_torch": "själsstikkliuos",
  "block.minecraft.glowstone": "glyöðstien",
  "block.minecraft.jack_o_lantern": "lykta, gard ov pumpu",
  "block.minecraft.oak_trapdoor": "iekfollukku",
  "block.minecraft.spruce_trapdoor": "grą̊follukku",
  "block.minecraft.birch_trapdoor": "byörkfollukku",
  "block.minecraft.jungle_trapdoor": "junggelluku",
  "block.minecraft.acacia_trapdoor": "akasiafollukku",
  "block.minecraft.dark_oak_trapdoor": "mörkiekfollukku",
  "block.minecraft.crimson_trapdoor": "mörkroð follukk",
  "block.minecraft.warped_trapdoor": "fevrengd follukku",
  "block.minecraft.infested_stone": "smittað stie",
  "block.minecraft.infested_cobblestone": "smittað gatustįe",
  "block.minecraft.infested_stone_bricks": "smittað stįetigelstie",
  "block.minecraft.infested_mossy_stone_bricks": "mossug stįetigelstie",
  "block.minecraft.infested_cracked_stone_bricks": "smittað sprutjintigelstie",
  "block.minecraft.infested_chiseled_stone_bricks": "smittað mejslað stįetigelstie",
  "block.minecraft.stone_bricks": "stįetigelstie",
  "block.minecraft.mossy_stone_bricks": "mossun stįetigelstie",
  "block.minecraft.cracked_stone_bricks": "klumnað st stįetigelstie",
  "block.minecraft.chiseled_stone_bricks": "mejslað stįetigelstie",
  "block.minecraft.brown_mushroom_block": "brun soppblokk",
  "block.minecraft.red_mushroom_block": "roð soppblokk",
  "block.minecraft.mushroom_stem": "soppstjälk",
  "block.minecraft.iron_bars": "ienngalder",
  "block.minecraft.chain": "tjaia",
  "block.minecraft.glass_pane": "glasrut",
  "block.minecraft.melon": "meluon",
  "block.minecraft.vine": "kleðerwekst",
  "block.minecraft.oak_fence_gate": "grind i iekstakiet",
  "block.minecraft.spruce_fence_gate": "grind i grą̊stakiet",
  "block.minecraft.birch_fence_gate": "grind i byörkstakiet",
  "block.minecraft.jungle_fence_gate": "grind i jungelstakiet",
  "block.minecraft.acacia_fence_gate": "grind i akasiastakiet",
  "block.minecraft.dark_oak_fence_gate": "grind i mörkiekstakiet",
  "block.minecraft.crimson_fence_gate": "mörkroð dörer i stakiet",
  "block.minecraft.warped_fence_gate": "fevrengd grind",
  "block.minecraft.brick_stairs": "tigelstįetrampur",
  "block.minecraft.stone_brick_stairs": "stįetigelstietrampur",
  "block.minecraft.mycelium": "mysel",
  "block.minecraft.lily_pad": "lerblað",
  "block.minecraft.nether_bricks": "nethertigelstiener",
  "block.minecraft.cracked_nether_bricks": "rimnað netherstiener",
  "block.minecraft.chiseled_nether_bricks": "mejslað nethertigelstiener",
  "block.minecraft.nether_brick_fence": "nethertigelstįestakiet",
  "block.minecraft.nether_brick_stairs": "nethertigelstįetrampur",
  "block.minecraft.enchanting_table": "fertrullninggsbuord",
  "block.minecraft.end_portal_frame": "endportalram",
  "block.minecraft.end_stone": "slutstie",
  "block.minecraft.end_stone_bricks": "sluttigelstiener",
  "block.minecraft.dragon_egg": "drakeddję",
  "block.minecraft.redstone_lamp": "redstonelampa",
  "block.minecraft.sandstone_stairs": "sandstįetrampur",
  "block.minecraft.emerald_ore": "smaragdåðer",
  "block.minecraft.ender_chest": "endertjist",
  "block.minecraft.tripwire_hook": "styppeltråðkruok",
  "block.minecraft.emerald_block": "smaragdblokk",
  "block.minecraft.spruce_stairs": "grǫtrampur",
  "block.minecraft.birch_stairs": "byörktrampur",
  "block.minecraft.jungle_stairs": "junggeltrampur",
  "block.minecraft.crimson_stairs": "mörkroð trampur",
  "block.minecraft.warped_stairs": "fevrengd trampur",
  "block.minecraft.command_block": "kommandoblokk",
  "block.minecraft.beacon": "fyr",
  "block.minecraft.cobblestone_wall": "gatustįewegg",
  "block.minecraft.mossy_cobblestone_wall": "mossug gatustįewegg",
  "block.minecraft.brick_wall": "tigelstiewegg",
  "block.minecraft.prismarine_wall": "prismarinwegg",
  "block.minecraft.red_sandstone_wall": "roð sandstįewegg",
  "block.minecraft.mossy_stone_brick_wall": "muossun stįetigelstįewegg",
  "block.minecraft.granite_wall": "granitwegg",
  "block.minecraft.stone_brick_wall": "stįetigelstįewegg",
  "block.minecraft.nether_brick_wall": "nethertigelstįewegg",
  "block.minecraft.andesite_wall": "andesitwegg",
  "block.minecraft.red_nether_brick_wall": "roð nethertigelstįewegg",
  "block.minecraft.sandstone_wall": "sanstįewegg",
  "block.minecraft.end_stone_brick_wall": "slutstietigelstįewegg",
  "block.minecraft.diorite_wall": "dioritwegg",
  "block.minecraft.blackstone_wall": "swartstįemuor",
  "block.minecraft.polished_blackstone_wall": "polirað muor ov swartstien",
  "block.minecraft.polished_blackstone_brick_wall": "muor ov poliraðer swartstįestiener",
  "block.minecraft.stone_button": "stįeknapp",
  "block.minecraft.oak_button": "iekknapp",
  "block.minecraft.spruce_button": "grǫknapp",
  "block.minecraft.birch_button": "byörkknapp",
  "block.minecraft.jungle_button": "jungelknapp",
  "block.minecraft.acacia_button": "akasiaknapp",
  "block.minecraft.dark_oak_button": "mörkiekknapp",
  "block.minecraft.crimson_button": "mörkroð knapp",
  "block.minecraft.warped_button": "fevrengd knapp",
  "block.minecraft.polished_blackstone_button": "polirað swartstįeknapp",
  "block.minecraft.anvil": "smiðsteð",
  "block.minecraft.chipped_anvil": "skardut smiðsteð",
  "block.minecraft.damaged_anvil": "skåðåð smiðsteð",
  "block.minecraft.trapped_chest": "instainggd tjist",
  "block.minecraft.light_weighted_pressure_plate": "litt pressplatt",
  "block.minecraft.heavy_weighted_pressure_plate": "tungg pressplatt",
  "block.minecraft.daylight_detector": "dagsljuosdetektor",
  "block.minecraft.redstone_block": "redstoneblokk",
  "block.minecraft.nether_quartz_ore": "netherkwartsåðer",
  "block.minecraft.hopper": "tratt",
  "block.minecraft.chiseled_quartz_block": "mejslað kwartsblokk",
  "block.minecraft.quartz_block": "kwartsblokk",
  "block.minecraft.quartz_bricks": "tigelstiener ov kwarts",
  "block.minecraft.quartz_pillar": "kwartspiler",
  "block.minecraft.quartz_stairs": "kwartstrampur",
  "block.minecraft.activator_rail": "rels min aktivator",
  "block.minecraft.dropper": "autmäter",
  "block.minecraft.white_terracotta": "waitt terrakotta",
  "block.minecraft.orange_terracotta": "guolroð terrakotta",
  "block.minecraft.magenta_terracotta": "magenta terrakotta",
  "block.minecraft.light_blue_terracotta": "ljuosblå terrakotta",
  "block.minecraft.yellow_terracotta": "guol terrakotta",
  "block.minecraft.lime_terracotta": "limeferagðterrakott",
  "block.minecraft.pink_terracotta": "stjär terrakotta",
  "block.minecraft.gray_terracotta": "grå terrakotta",
  "block.minecraft.light_gray_terracotta": "ljuosgrå terrakotta",
  "block.minecraft.cyan_terracotta": "cyanfergað terrakotta",
  "block.minecraft.purple_terracotta": "lila terrakotta",
  "block.minecraft.blue_terracotta": "blå terrakotta",
  "block.minecraft.brown_terracotta": "brun terakotta",
  "block.minecraft.green_terracotta": "gryön terrakotta",
  "block.minecraft.red_terracotta": "roð terrakotta",
  "block.minecraft.black_terracotta": "swart terrakotta",
  "block.minecraft.barrier": "inder",
  "block.minecraft.iron_trapdoor": "iennfollukku",
  "block.minecraft.hay_block": "öbal",
  "block.minecraft.white_carpet": "wait matta",
  "block.minecraft.orange_carpet": "guolroð matta",
  "block.minecraft.magenta_carpet": "liuoslila matta",
  "block.minecraft.light_blue_carpet": "liuosblå matta",
  "block.minecraft.yellow_carpet": "guol matta",
  "block.minecraft.lime_carpet": "limegryön matta",
  "block.minecraft.pink_carpet": "rosa matta",
  "block.minecraft.gray_carpet": "grå matta",
  "block.minecraft.light_gray_carpet": "liuosgrå matta",
  "block.minecraft.cyan_carpet": "syanfergað matta",
  "block.minecraft.purple_carpet": "lila matta",
  "block.minecraft.blue_carpet": "blå matta",
  "block.minecraft.brown_carpet": "brun matta",
  "block.minecraft.green_carpet": "gryön matta",
  "block.minecraft.red_carpet": "roð matta",
  "block.minecraft.black_carpet": "swart matta",
  "block.minecraft.terracotta": "terrakotta",
  "block.minecraft.coal_block": "kuolblokk",
  "block.minecraft.packed_ice": "pakkað ais",
  "block.minecraft.acacia_stairs": "akasiatrampur",
  "block.minecraft.dark_oak_stairs": "mörkiektrampur",
  "block.minecraft.slime_block": "kliemblokk",
  "block.minecraft.grass_path": "grasstaig",
  "block.minecraft.sunflower": "suolruos",
  "block.minecraft.lilac": "syriener",
  "block.minecraft.rose_bush": "ruosbuosk",
  "block.minecraft.peony": "piuon",
  "block.minecraft.tall_grass": "launggras",
  "block.minecraft.large_fern": "sturuormbunk",
  "block.minecraft.white_stained_glass": "waitflekkaðglas",
  "block.minecraft.orange_stained_glass": "orandjflekkaðglas",
  "block.minecraft.magenta_stained_glass": "magentaflekkaðglas",
  "block.minecraft.light_blue_stained_glass": "ljuosblåflekkaðglas",
  "block.minecraft.yellow_stained_glass": "guolflekkaðglas",
  "block.minecraft.lime_stained_glass": "laimflekkaðglas",
  "block.minecraft.pink_stained_glass": "stjärflekkaðglas",
  "block.minecraft.gray_stained_glass": "gråflekkaðglas",
  "block.minecraft.light_gray_stained_glass": "ljuosgråflekkaðglas",
  "block.minecraft.cyan_stained_glass": "syanflekkaðglas",
  "block.minecraft.purple_stained_glass": "lilaflekkaðglas",
  "block.minecraft.blue_stained_glass": "blåflekkaðglas",
  "block.minecraft.brown_stained_glass": "brunflekkaðglas",
  "block.minecraft.green_stained_glass": "gryönflekkaðglas",
  "block.minecraft.red_stained_glass": "roðflekkaðglas",
  "block.minecraft.black_stained_glass": "swartflekkaðglas",
  "block.minecraft.white_stained_glass_pane": "waitflekkaðglasrut",
  "block.minecraft.orange_stained_glass_pane": "orandjflekkaðglasrut",
  "block.minecraft.magenta_stained_glass_pane": "magentaflekkaðglasrut",
  "block.minecraft.light_blue_stained_glass_pane": "ljuosblåflekkaðglasrut",
  "block.minecraft.yellow_stained_glass_pane": "guolflekkaðglasrut",
  "block.minecraft.lime_stained_glass_pane": "kalkflekkaðglasrut",
  "block.minecraft.pink_stained_glass_pane": "stjärflekkaðglasrut",
  "block.minecraft.gray_stained_glass_pane": "gråflekkaðglasrut",
  "block.minecraft.light_gray_stained_glass_pane": "ljuosgråflekkaðglasrut",
  "block.minecraft.cyan_stained_glass_pane": "cyanflekkaðglasrut",
  "block.minecraft.purple_stained_glass_pane": "lilaflekkaðglasrut",
  "block.minecraft.blue_stained_glass_pane": "blåflekkaðglasrut",
  "block.minecraft.brown_stained_glass_pane": "brunflekkaðglasrut",
  "block.minecraft.green_stained_glass_pane": "gryönflekkaðglasrut",
  "block.minecraft.red_stained_glass_pane": "rodflekkaðglasrut",
  "block.minecraft.black_stained_glass_pane": "swartflekkaðglasrut",
  "block.minecraft.prismarine": "prismarin",
  "block.minecraft.prismarine_bricks": "prismarin tigelstiener",
  "block.minecraft.dark_prismarine": "mörk prismarin",
  "block.minecraft.prismarine_stairs": "prismarintrampur",
  "block.minecraft.prismarine_brick_stairs": "prismarin tigeltrampur",
  "block.minecraft.dark_prismarine_stairs": "mörk prismarintrampur",
  "block.minecraft.sea_lantern": "sjulantern",
  "block.minecraft.red_sandstone": "roðsandstie",
  "block.minecraft.chiseled_red_sandstone": "mejslað roðsandstie",
  "block.minecraft.cut_red_sandstone": "klippt sandstie",
  "block.minecraft.red_sandstone_stairs": "roðsandstįetrampur",
  "block.minecraft.repeating_command_block": "repetirend kommandoblokk",
  "block.minecraft.chain_command_block": "umtagend kommandoblokk",
  "block.minecraft.magma_block": "magmablokk",
  "block.minecraft.nether_wart_block": "netherwårtblokk",
  "block.minecraft.warped_wart_block": "neðerwartblokk",
  "block.minecraft.red_nether_bricks": "roð nethertigelstiener",
  "block.minecraft.bone_block": "bįeblokk",
  "block.minecraft.structure_void": "stukrturtuomruom",
  "block.minecraft.observer": "observatör",
  "block.minecraft.shulker_box": "shulkerlåð",
  "block.minecraft.white_shulker_box": "wait shulkerlåða",
  "block.minecraft.orange_shulker_box": "guolroð shulkerlåða",
  "block.minecraft.magenta_shulker_box": "liuoslila shulkerlåða",
  "block.minecraft.light_blue_shulker_box": "liuosblå shulkerlåða",
  "block.minecraft.yellow_shulker_box": "guol shulkerlåða",
  "block.minecraft.lime_shulker_box": "laimfergað shulkerlåð",
  "block.minecraft.pink_shulker_box": "stjär shulkerlåða",
  "block.minecraft.gray_shulker_box": "grå shulkerlåð",
  "block.minecraft.light_gray_shulker_box": "liuosgrå shulkerlåð",
  "block.minecraft.cyan_shulker_box": "cyanfergað shulkerlåð",
  "block.minecraft.purple_shulker_box": "lila shulkerlåð",
  "block.minecraft.blue_shulker_box": "blå shulkerlåð",
  "block.minecraft.brown_shulker_box": "brun shulkerlåð",
  "block.minecraft.green_shulker_box": "gryön shulkerlåð",
  "block.minecraft.red_shulker_box": "roð shulkerlåð",
  "block.minecraft.black_shulker_box": "swart shulkerlåð",
  "block.minecraft.white_glazed_terracotta": "waitglasirað terrakotta",
  "block.minecraft.orange_glazed_terracotta": "orangeglasirað terrakotta",
  "block.minecraft.magenta_glazed_terracotta": "magentaglasirað terrakotta",
  "block.minecraft.light_blue_glazed_terracotta": "ljuosblåglasirað terrakotta",
  "block.minecraft.yellow_glazed_terracotta": "guolglasirað terrakotta",
  "block.minecraft.lime_glazed_terracotta": "laimfergað glasirað terrakotta",
  "block.minecraft.pink_glazed_terracotta": "stjärglasirað terrakotta",
  "block.minecraft.gray_glazed_terracotta": "gråglasirað terrakotta",
  "block.minecraft.light_gray_glazed_terracotta": "syanglasirað terrakotta",
  "block.minecraft.cyan_glazed_terracotta": "syanfergað glasirað terrakotta",
  "block.minecraft.purple_glazed_terracotta": "purpurglasirad terrakotta",
  "block.minecraft.blue_glazed_terracotta": "blåglasirað terrakotta",
  "block.minecraft.brown_glazed_terracotta": "brunglasirað terrakotta",
  "block.minecraft.green_glazed_terracotta": "gryönglasirað terrakotta",
  "block.minecraft.red_glazed_terracotta": "roðglasirað terrakotta",
  "block.minecraft.black_glazed_terracotta": "swartglasirað terrakotta",
  "block.minecraft.white_concrete": "wait bitongg",
  "block.minecraft.orange_concrete": "guolroð bitongg",
  "block.minecraft.magenta_concrete": "liuoslila bitongg",
  "block.minecraft.light_blue_concrete": "liuosblå bitongg",
  "block.minecraft.yellow_concrete": "guol bitongg",
  "block.minecraft.lime_concrete": "limegryön bitongg",
  "block.minecraft.pink_concrete": "råsa bitongg",
  "block.minecraft.gray_concrete": "grå bitongg",
  "block.minecraft.light_gray_concrete": "liuosgrå bitongg",
  "block.minecraft.cyan_concrete": "syanfergað bitongg",
  "block.minecraft.purple_concrete": "lila bitongg",
  "block.minecraft.blue_concrete": "blå bitongg",
  "block.minecraft.brown_concrete": "brun bitongg",
  "block.minecraft.green_concrete": "gryön bitongg",
  "block.minecraft.red_concrete": "roð bitongg",
  "block.minecraft.black_concrete": "swart bitongg",
  "block.minecraft.white_concrete_powder": "wait bitonggpulver",
  "block.minecraft.orange_concrete_powder": "guolroð bitonggpulver",
  "block.minecraft.magenta_concrete_powder": "liuoslila bitonggpulver",
  "block.minecraft.light_blue_concrete_powder": "liuosblå bitonggpulver",
  "block.minecraft.yellow_concrete_powder": "guolt bitonggpulver",
  "block.minecraft.lime_concrete_powder": "limegryön bitonggpulver",
  "block.minecraft.pink_concrete_powder": "råsa bitonggpulver",
  "block.minecraft.gray_concrete_powder": "grå bitonggpulver",
  "block.minecraft.light_gray_concrete_powder": "liuosgrå bitonggpulver",
  "block.minecraft.cyan_concrete_powder": "syanfergað bitonggpulver",
  "block.minecraft.purple_concrete_powder": "lila bitonggpulver",
  "block.minecraft.blue_concrete_powder": "blå bitonggpulver",
  "block.minecraft.brown_concrete_powder": "brun bitonggpulver",
  "block.minecraft.green_concrete_powder": "gryön bitonggpulver",
  "block.minecraft.red_concrete_powder": "roð bitonggpulver",
  "block.minecraft.black_concrete_powder": "swart bitongpulver",
  "block.minecraft.turtle_egg": "stjöldkluossegg",
  "block.minecraft.dead_tube_coral_block": "dod rörkorallblokk",
  "block.minecraft.dead_brain_coral_block": "doð iennkorallblokk",
  "block.minecraft.dead_bubble_coral_block": "doð bubbellkorallblock",
  "block.minecraft.dead_fire_coral_block": "doð jäldkorallblokk",
  "block.minecraft.dead_horn_coral_block": "doð uonnkorallblokk",
  "block.minecraft.tube_coral_block": "rörkorallblokk",
  "block.minecraft.brain_coral_block": "iennkorallblokk",
  "block.minecraft.bubble_coral_block": "bubbelkorallblokk",
  "block.minecraft.fire_coral_block": "jäldkorallblokk",
  "block.minecraft.horn_coral_block": "uonnkorallblokk",
  "block.minecraft.tube_coral": "rörkorall",
  "block.minecraft.brain_coral": "iennkorall",
  "block.minecraft.bubble_coral": "bubbelkorall",
  "block.minecraft.fire_coral": "jäldkorall",
  "block.minecraft.horn_coral": "uonnkorall",
  "block.minecraft.dead_brain_coral": "doð iennkorall",
  "block.minecraft.dead_bubble_coral": "doð bubbelkorall",
  "block.minecraft.dead_fire_coral": "doð jäldkorall",
  "block.minecraft.dead_horn_coral": "doð uonnkorall",
  "block.minecraft.dead_tube_coral": "doð rörkorall",
  "block.minecraft.tube_coral_fan": "rörkorallflekt",
  "block.minecraft.brain_coral_fan": "iennkorallflekt",
  "block.minecraft.bubble_coral_fan": "bubbelkorallflekt",
  "block.minecraft.fire_coral_fan": "jäldkorallflekt",
  "block.minecraft.horn_coral_fan": "uonnkorallflekt",
  "block.minecraft.dead_tube_coral_fan": "doð rörkorallflekt",
  "block.minecraft.dead_brain_coral_fan": "doð iennkorallflekt",
  "block.minecraft.dead_bubble_coral_fan": "doð bubbelkorallflekt",
  "block.minecraft.dead_fire_coral_fan": "doð jäldkorallflekt",
  "block.minecraft.dead_horn_coral_fan": "doð uonnkorallflekt",
  "block.minecraft.blue_ice": "blåaisn",
  "block.minecraft.conduit": "kultvert",
  "block.minecraft.polished_granite_stairs": "poliraðer granittrampur",
  "block.minecraft.smooth_red_sandstone_stairs": "blot roðsandstįetrampur",
  "block.minecraft.mossy_stone_brick_stairs": "mossug tigelstįetrampur",
  "block.minecraft.polished_diorite_stairs": "poliraðer diorittrampur",
  "block.minecraft.mossy_cobblestone_stairs": "mossug gatustįetrampur",
  "block.minecraft.end_stone_brick_stairs": "endstįetigelstįetrampur",
  "block.minecraft.stone_stairs": "stįetrampur",
  "block.minecraft.smooth_sandstone_stairs": "blot sandstįetrampur",
  "block.minecraft.smooth_quartz_stairs": "blot kwartstrampur",
  "block.minecraft.granite_stairs": "granittrampur",
  "block.minecraft.andesite_stairs": "andesittrampur",
  "block.minecraft.red_nether_brick_stairs": "roðu nethertigelstįetrampur",
  "block.minecraft.polished_andesite_stairs": "poliraðer andesittrampur",
  "block.minecraft.diorite_stairs": "diorittrampur",
  "block.minecraft.polished_granite_slab": "polirað granitstjiv",
  "block.minecraft.smooth_red_sandstone_slab": "blot roð sandstįestjiv",
  "block.minecraft.mossy_stone_brick_slab": "mossun stietigelstįestjiv",
  "block.minecraft.polished_diorite_slab": "polirað dioritstjiv",
  "block.minecraft.mossy_cobblestone_slab": "muosun gatustiestjiv",
  "block.minecraft.end_stone_brick_slab": "endtigelsstįestjiv",
  "block.minecraft.smooth_sandstone_slab": "blot sandstįestjiv",
  "block.minecraft.smooth_quartz_slab": "blot kwartsstjiv",
  "block.minecraft.granite_slab": "granitstjiv",
  "block.minecraft.andesite_slab": "andesitstjiv",
  "block.minecraft.red_nether_brick_slab": "rod nethertigelstįestjiv",
  "block.minecraft.polished_andesite_slab": "polirað andesitstjiv",
  "block.minecraft.diorite_slab": "diroitstjiv",
  "block.minecraft.scaffolding": "byggstellningg",
  "block.minecraft.iron_door": "ienndörer",
  "block.minecraft.oak_door": "iekdörer",
  "block.minecraft.spruce_door": "grą̊dörer",
  "block.minecraft.birch_door": "byörkdörer",
  "block.minecraft.jungle_door": "junggeldörer",
  "block.minecraft.acacia_door": "acasiadörer",
  "block.minecraft.dark_oak_door": "mörkiekdörer",
  "block.minecraft.crimson_door": "mörkroð dörer",
  "block.minecraft.warped_door": "fevrengd dörer",
  "block.minecraft.repeater": "redstonestutterer",
  "block.minecraft.comparator": "redstonejemfyörer",
  "block.minecraft.structure_block": "strukturblokk",
  "block.minecraft.jigsaw": "pusselblokk",
  "item.minecraft.turtle_helmet": "stjöldkluossskal□□bar ðu ar ą̊ skollam:□+2 rustningg",
  "item.minecraft.scute": "skalbiter",
  "item.minecraft.iron_shovel": "iennspaði□□bar ðu ar i nevån du bruker mjäst ov:□+3.5 atakkskåðå□-3 atakkfart",
  "item.minecraft.iron_pickaxe": "iennakka□□bar ðu ar i nevån du bruker mjäst ov:□+3 atakkskåðå□-2.8 atakkfart",
  "item.minecraft.iron_axe": "iennökse□□bar ðu ar i nevån du bruker mjäst ov:□+8 atakkskåðå□-3.1 atakkfart",
  "item.minecraft.flint_and_steel": "jäldfyör",
  "item.minecraft.apple": "eppel",
  "item.minecraft.bow": "kuovbugi",
  "item.minecraft.arrow": "kuov",
  "item.minecraft.coal": "kuol",
  "item.minecraft.charcoal": "träkuol",
  "item.minecraft.diamond": "diamant",
  "item.minecraft.iron_ingot": "ienntakka",
  "item.minecraft.gold_ingot": "gulltakka",
  "item.minecraft.netherite_ingot": "netherittakka",
  "item.minecraft.netherite_scrap": "netheritskruot",
  "item.minecraft.iron_sword": "iennswärd□□bar ðu ar i nevån du bruker mjäst ov:□+5 atakkskåðå□-2.4 atakkfart",
  "item.minecraft.wooden_sword": "wiðåswärd□□bar ðu ar i nevån du bruker mjäst ov:□+3 atakkskåðå□-2.4 atakkfart",
  "item.minecraft.wooden_shovel": "wiðåspaði□□bar ðu ar i nevån du bruker mjäst ov:□+1.5 atakkskåðå□-3 atakkfart",
  "item.minecraft.wooden_pickaxe": "wiðåakka□□bar ðu ar i nevån du bruker mjäst ov:□+1 atakkskåðå□-2.8 atakkfart",
  "item.minecraft.wooden_axe": "wiðåöks□□bar ðu ar i nevån du bruker mjäst ov:□+6 atakkskåðå□-3.2 atakkfart",
  "item.minecraft.stone_sword": "stįeswärd□□bar ðu ar i nevån du bruker mjäst ov:□+4 atakkskåðå□-2.4 atakkfart",
  "item.minecraft.stone_shovel": "stįesreku□□bar ðu ar i nevån du bruker mjäst ov:□+2.5 atakkskåðå□-3 atakkfart",
  "item.minecraft.stone_pickaxe": "stįeakka□□bar ðu ar i nevån du bruker mjäst ov:□+2 atakkskåðå□-2.8 atakkfart",
  "item.minecraft.stone_axe": "stįeökse□□bar ðu ar i nevån du bruker mjäst ov:□+8 atakkskåðå□-3.2 atakkfart",
  "item.minecraft.diamond_sword": "diamantswärd□□bar ðu ar i nevån du bruker mjäst ov:□+6 atakkskåðå□-2.4 atakkfart",
  "item.minecraft.diamond_shovel": "diamantreku□□bar ðu ar i nevån du bruker mjäst ov:□+4.5 atakkskåðå□-3 atakkfart",
  "item.minecraft.diamond_pickaxe": "diamantakka□□bar ðu ar i nevån du bruker mjäst ov:□+4 atakkskåðå□-2.8 atakkfart",
  "item.minecraft.diamond_axe": "diamantökse□□bar ðu ar i nevån du bruker mjäst ov:□+8 atakkskåðå□-3 atakkfart",
  "item.minecraft.stick": "pinne",
  "item.minecraft.bowl": "skål",
  "item.minecraft.mushroom_stew": "soppstuvningg",
  "item.minecraft.golden_sword": "gullswärd□□bar ðu ar i nevån du bruker mjäst ov:□+3 atakkskåðå□-2.4 atakkfart",
  "item.minecraft.golden_shovel": "gullspaði□□bar ðu ar i nevån du bruker mjäst ov:□+1.5 atakkskåðå□-3 atakkfart",
  "item.minecraft.golden_pickaxe": "gullakka□□bar ðu ar i nevån du bruker mjäst ov:□+1 atakkskåðå□-2.8 atakkfart",
  "item.minecraft.golden_axe": "gullökse□□bar ðu ar i nevån du bruker mjäst ov:□+6 atakkskåðå□-3 atakkfart",
  "item.minecraft.netherite_sword": "netheriteswärd□□bar ðu ar i nevån du bruker mjäst ov:□+7 atakkskåðå□-2.4 atakkfart",
  "item.minecraft.netherite_shovel": "netheritestjyffel□□bar ðu ar i nevån du bruker mjäst ov:□+5.5 atakkskåðå□-3 atakkfart",
  "item.minecraft.netherite_pickaxe": "netheriteakka□□bar ðu ar i nevån du bruker mjäst ov:□+5 atakkskåðå□-2.8 atakkfart",
  "item.minecraft.netherite_axe": "netheriteöks□□bar ðu ar i nevån du bruker mjäst ov:□+9 atakkskåðå□-3 atakkfart",
  "item.minecraft.string": "tråð",
  "item.minecraft.feather": "fjäðer",
  "item.minecraft.gunpowder": "krut",
  "item.minecraft.wooden_hoe": "wiðåflåakk□□bar ðu ar i nevån du bruker mjäst ov:□-3 atakkfart",
  "item.minecraft.stone_hoe": "stįeflåakk□□bar ðu ar i nevån du bruker mjäst ov:□-2 atakkfart",
  "item.minecraft.iron_hoe": "iennflåakk□□bar ðu ar i nevån du bruker mjäst ov:□-1 atakkfart",
  "item.minecraft.diamond_hoe": "diamantflåakk□□bar ðu ar i nevån du bruker mjäst ov:",
  "item.minecraft.golden_hoe": "gullflåakk□□bar ðu ar i nevån du bruker mjäst ov:□-3 atakkfart",
  "item.minecraft.netherite_hoe": "netheriteflåakk□□bar ðu ar i nevån du bruker mjäst ov:",
  "item.minecraft.wheat_seeds": "waitkuonn",
  "item.minecraft.wheat": "waita",
  "item.minecraft.bread": "bröð",
  "item.minecraft.leather_helmet": "leðerett□□bar ðu ar ą̊ skollam:□+1 rustningg",
  "item.minecraft.leather_chestplate": "leðertunika□□bar ðu ar ą̊ kruppem:□+3 rustningg",
  "item.minecraft.leather_leggings": "leðerbruok□□bar ðu ar ą̊ fuotum:□+2 rustningg",
  "item.minecraft.leather_boots": "leðerstyvler□□bar ðu ar ą̊ fuotum:□+1 rustningg",
  "item.minecraft.chainmail_helmet": "ringbrynsjelm□□bar ðu ar ą̊ skollam:□+2 rustningg",
  "item.minecraft.chainmail_chestplate": "ringbrynsbreststjiv□□bar ðu ar ą̊ kruppem:□+5 rustningg",
  "item.minecraft.chainmail_leggings": "ringbrynsuosur□□bar ðu ar ą̊ fuotum:□+4 rustningg",
  "item.minecraft.chainmail_boots": "ringbrynsstyvler□□bar ðu ar ą̊ fuotum:□+1 rustningg",
  "item.minecraft.iron_helmet": "iennjelm□□bar ðu ar ą̊ skollam:□+2 rustningg",
  "item.minecraft.iron_chestplate": "iennbreststjiv□□bar ðu ar ą̊ kruppem:□+6 rustningg",
  "item.minecraft.iron_leggings": "iennuosur□□bar ðu ar ą̊ fuotum:□+5 rustningg",
  "item.minecraft.iron_boots": "iennstyvler□□bar ðu ar ą̊ fuotum:□+2 rustningg",
  "item.minecraft.diamond_helmet": "diamantjelm□□bar ðu ar ą̊ skollam:□+3 rustningg□+2 rustninggsstyrka",
  "item.minecraft.diamond_chestplate": "diamantbreststjiv□□bar ðu ar ą̊ kruppem:□+8 rustningg□+2 rustninggsstyrka",
  "item.minecraft.diamond_leggings": "diamantuosur□□bar ðu ar ą̊ fuotum:□+6 rustningg□+2 rustninggsstyrka",
  "item.minecraft.diamond_boots": "diamantstyvler□□bar ðu ar ą̊ fuotum:□+3 rustningg□+2 rustninggsstyrka",
  "item.minecraft.golden_helmet": "gulljelm□□bar ðu ar ą̊ skollam:□+2 rustningg",
  "item.minecraft.golden_chestplate": "gullbreststjiv□□bar ðu ar ą̊ kruppem:□+5 rustningg",
  "item.minecraft.golden_leggings": "gulluosur□□bar ðu ar ą̊ fuotum:□+3 rustningg",
  "item.minecraft.golden_boots": "gullstyvler□□bar ðu ar ą̊ fuotum:□+1 rustningg",
  "item.minecraft.netherite_helmet": "netheritjelm□□bar ðu ar ą̊ skollam:□+3 rustningg□+3 rustninggsstyrka□+1 muotstånd muot tilbukkningg",
  "item.minecraft.netherite_chestplate": "netheritharnesk□□bar ðu ar ą̊ kruppem:□+8 rustningg□+3 rustninggsstyrka□+1 muotstånd muot tilbukkningg",
  "item.minecraft.netherite_leggings": "netheritebruok□□bar ðu ar ą̊ fuotum:□+6 rustningg□+3 rustninggsstyrka□+1 muotstånd muot tilbukkningg",
  "item.minecraft.netherite_boots": "netheritstyvler□□bar ðu ar ą̊ fuotum:□+3 rustningg□+3 rustninggsstyrka□+1 muotstånd muot tilbukkningg",
  "item.minecraft.flint": "flinta",
  "item.minecraft.porkchop": "rå fleskkotlett",
  "item.minecraft.cooked_porkchop": "stiekt fleskkotlett",
  "item.minecraft.painting": "tavel",
  "item.minecraft.golden_apple": "gulleppel",
  "item.minecraft.enchanted_golden_apple": "fertryllað gulleppel",
  "block.minecraft.oak_sign": "iekstjylt",
  "block.minecraft.spruce_sign": "grǫstşylt",
  "block.minecraft.birch_sign": "byörkstjylt",
  "block.minecraft.jungle_sign": "junggelstjylt",
  "block.minecraft.acacia_sign": "akasiastjylt",
  "block.minecraft.dark_oak_sign": "mörkiekstjylt",
  "block.minecraft.crimson_sign": "mörkroð stjylt",
  "block.minecraft.warped_sign": "fevrengd stjylt",
  "item.minecraft.bucket": "kruka",
  "item.minecraft.water_bucket": "wattukruk",
  "item.minecraft.lava_bucket": "lavakruk",
  "item.minecraft.minecart": "gruvvangin",
  "item.minecraft.saddle": "sa’ll",
  "item.minecraft.redstone": "redstonedamb",
  "item.minecraft.snowball": "sniųoboll",
  "item.minecraft.oak_boat": "iekbåt",
  "item.minecraft.leather": "leðer",
  "item.minecraft.milk_bucket": "mjokkruk",
  "item.minecraft.pufferfish_bucket": "kruk min puff-fiskum",
  "item.minecraft.salmon_bucket": "kruk min oraðum",
  "item.minecraft.cod_bucket": "kruk min tosk",
  "item.minecraft.tropical_fish_bucket": "kruk min tropikfiskum",
  "item.minecraft.brick": "tigelstie",
  "item.minecraft.clay_ball": "lierbolld",
  "block.minecraft.dried_kelp_block": "blokk ov torkað alg",
  "item.minecraft.paper": "papir",
  "item.minecraft.book": "buok",
  "item.minecraft.slime_ball": "kliemboll",
  "item.minecraft.chest_minecart": "gruvvangin min lådų",
  "item.minecraft.furnace_minecart": "gruvvangin min smeltungen",
  "item.minecraft.egg": "egg",
  "item.minecraft.compass": "kumpass",
  "item.minecraft.fishing_rod": "fiskspuoð",
  "item.minecraft.clock": "klukka",
  "item.minecraft.glowstone_dust": "glyöðstįedamm",
  "item.minecraft.cod": "rå tosk",
  "item.minecraft.salmon": "rå orað",
  "item.minecraft.tropical_fish": "tropisk fisk",
  "item.minecraft.pufferfish": "puff-fisk",
  "item.minecraft.cooked_cod": "kuokað tosk",
  "item.minecraft.cooked_salmon": "kuokað orað",
  "item.minecraft.ink_sac": "blekksjäk",
  "item.minecraft.red_dye": "roðferg",
  "item.minecraft.green_dye": "gryönferg",
  "item.minecraft.cocoa_beans": "soklaðbyönur",
  "item.minecraft.lapis_lazuli": "lapus lazuli",
  "item.minecraft.purple_dye": "lila ferg",
  "item.minecraft.cyan_dye": "syan ferg",
  "item.minecraft.light_gray_dye": "liuosgrå ferg",
  "item.minecraft.gray_dye": "grå ferg",
  "item.minecraft.pink_dye": "råsa ferg",
  "item.minecraft.lime_dye": "limegryön ferg",
  "item.minecraft.yellow_dye": "guol ferg",
  "item.minecraft.light_blue_dye": "liuosblå ferg",
  "item.minecraft.magenta_dye": "liuoslila ferg",
  "item.minecraft.orange_dye": "guolroð ferg",
  "item.minecraft.bone_meal": "biemyöl",
  "item.minecraft.blue_dye": "blå ferg",
  "item.minecraft.brown_dye": "brun ferg",
  "item.minecraft.black_dye": "swart ferg",
  "item.minecraft.white_dye": "wait ferg",
  "item.minecraft.bone": "bien",
  "item.minecraft.sugar": "sokker",
  "block.minecraft.cake": "tårta",
  "block.minecraft.white_bed": "waitsaingg",
  "block.minecraft.orange_bed": "guolroð saingg",
  "block.minecraft.magenta_bed": "liuoslila saingg",
  "block.minecraft.light_blue_bed": "liuosblå saingg",
  "block.minecraft.yellow_bed": "guol saingg",
  "block.minecraft.lime_bed": "limegryön saingg",
  "block.minecraft.pink_bed": "stjär saingg",
  "block.minecraft.gray_bed": "grå saingg",
  "block.minecraft.light_gray_bed": "liuosgrå saingg",
  "block.minecraft.cyan_bed": "syansaingg",
  "block.minecraft.purple_bed": "lila saingg",
  "block.minecraft.blue_bed": "blå saingg",
  "block.minecraft.brown_bed": "brun saingg",
  "block.minecraft.green_bed": "gryön saingg",
  "block.minecraft.red_bed": "roð saingg",
  "block.minecraft.black_bed": "swart saingg",
  "item.minecraft.cookie": "kaku",
  "item.minecraft.filled_map": "karta□#0",
  "item.minecraft.shears": "saks",
  "item.minecraft.melon_slice": "melonstjiv",
  "item.minecraft.dried_kelp": "torkað sjugras",
  "item.minecraft.pumpkin_seeds": "pumpstiener",
  "item.minecraft.melon_seeds": "melonstiener",
  "item.minecraft.beef": "råbiff",
  "item.minecraft.cooked_beef": "stiek",
  "item.minecraft.chicken": "råyöna",
  "item.minecraft.cooked_chicken": "kuokaðyöna",
  "item.minecraft.rotten_flesh": "rotnaðflestjeð",
  "item.minecraft.ender_pearl": "enderpärla",
  "item.minecraft.blaze_rod": "swigostor",
  "item.minecraft.ghast_tear": "ghasttår",
  "item.minecraft.gold_nugget": "gullklimp",
  "item.minecraft.nether_wart": "netherwårt",
  "item.minecraft.potion": "drykk eð går it djärå□ingg effekter",
  "item.minecraft.glass_bottle": "glasputell",
  "item.minecraft.spider_eye": "dyörgoga",
  "item.minecraft.fermented_spider_eye": "jäst dyörgog",
  "item.minecraft.blaze_powder": "flusåpuðer",
  "item.minecraft.magma_cream": "lavakrem",
  "block.minecraft.brewing_stand": "bryggstellningg",
  "block.minecraft.cauldron": "ketil",
  "item.minecraft.ender_eye": "enderog",
  "item.minecraft.glistering_melon_slice": "glistrend melonstjiv",
  "item.minecraft.bat_spawn_egg": "egg för te djärå leðrer",
  "item.minecraft.bee_spawn_egg": "egg fer te djärå bi minn",
  "item.minecraft.blaze_spawn_egg": "egg fer te djärå lugo",
  "item.minecraft.cat_spawn_egg": "egg fer te djärå katter",
  "item.minecraft.cave_spider_spawn_egg": "egg fer te djärå gråttdyörger",
  "item.minecraft.chicken_spawn_egg": "egg fer te djärå kykklingger",
  "item.minecraft.cod_spawn_egg": "egg fer te djärå tosker",
  "item.minecraft.cow_spawn_egg": "egg fer te djärå tjyrner",
  "item.minecraft.creeper_spawn_egg": "egg fer te djärå creeper",
  "item.minecraft.dolphin_spawn_egg": "egg fer te djärå delfiner",
  "item.minecraft.donkey_spawn_egg": "egg fer te djärå åsnur",
  "item.minecraft.drowned_spawn_egg": "drukknað tillwerkningsegg",
  "item.minecraft.elder_guardian_spawn_egg": "egg fer te djärå gamblinggswakter",
  "item.minecraft.enderman_spawn_egg": "egg fer te djärǫ enderkall",
  "item.minecraft.endermite_spawn_egg": "egg fer te djärå endermit",
  "item.minecraft.evoker_spawn_egg": "egg fer te djärå evoker",
  "item.minecraft.fox_spawn_egg": "egg fer te djärå rövir",
  "item.minecraft.ghast_spawn_egg": "egg fer te djärå ghast",
  "item.minecraft.guardian_spawn_egg": "egg fer te djärå wakter",
  "item.minecraft.hoglin_spawn_egg": "skapelseegg fer hoglin",
  "item.minecraft.horse_spawn_egg": "egg fer te djärå ester",
  "item.minecraft.husk_spawn_egg": "egg fer te djärå skälerer",
  "item.minecraft.llama_spawn_egg": "egg fer te djärå lamur",
  "item.minecraft.magma_cube_spawn_egg": "egg fer te djärå lavakuber",
  "item.minecraft.mooshroom_spawn_egg": "egg fer te djärå mooshroom",
  "item.minecraft.mule_spawn_egg": "egg fer te djärå mulur",
  "item.minecraft.ocelot_spawn_egg": "egg fer te djärå oceloter",
  "item.minecraft.panda_spawn_egg": "egg fer te djärå pandur",
  "item.minecraft.parrot_spawn_egg": "egg fer te djärå papegojur",
  "item.minecraft.phantom_spawn_egg": "egg fer te djärå spötjer",
  "item.minecraft.pig_spawn_egg": "egg fer te djärå graiser",
  "item.minecraft.piglin_spawn_egg": "skapelseegg fer piglin",
  "item.minecraft.pillager_spawn_egg": "egg fer te djärå röverer",
  "item.minecraft.polar_bear_spawn_egg": "egg fer te djärå aisbyönner",
  "item.minecraft.pufferfish_spawn_egg": "egg fer te djärå puff-fisker",
  "item.minecraft.rabbit_spawn_egg": "egg fer te djärå erir",
  "item.minecraft.ravager_spawn_egg": "egg fer te djärå festörerer",
  "item.minecraft.salmon_spawn_egg": "egg fer te djärå oraðir",
  "item.minecraft.sheep_spawn_egg": "egg fer te djärå takkur",
  "item.minecraft.shulker_spawn_egg": "egg fer te djärå shulker",
  "item.minecraft.silverfish_spawn_egg": "egg fer te djärå silverfisker",
  "item.minecraft.skeleton_spawn_egg": "egg fer te djärå skeletter",
  "item.minecraft.skeleton_horse_spawn_egg": "egg fer te djärå skelletester",
  "item.minecraft.slime_spawn_egg": "egg fer te djärå kliem",
  "item.minecraft.spider_spawn_egg": "egg fer te djärå dyörger",
  "item.minecraft.squid_spawn_egg": "egg fer te djärå blikfisker",
  "item.minecraft.stray_spawn_egg": "egg fer te djärå wavlerer",
  "item.minecraft.strider_spawn_egg": "skapelseegg fer wandrer",
  "item.minecraft.trader_llama_spawn_egg": "egg fer te djärå andelsmanlamur",
  "item.minecraft.tropical_fish_spawn_egg": "egg fer te djärå tropikfisker",
  "item.minecraft.turtle_spawn_egg": "egg fer te djärå stjöldkluossur",
  "item.minecraft.vex_spawn_egg": "egg fer te djärå biswerskupper",
  "item.minecraft.villager_spawn_egg": "egg fer te djärå byskaller",
  "item.minecraft.vindicator_spawn_egg": "egg fer te djärå förswarerer",
  "item.minecraft.wandering_trader_spawn_egg": "egg fe te djärå gråer",
  "item.minecraft.witch_spawn_egg": "egg fer te djärå eksur",
  "item.minecraft.wither_skeleton_spawn_egg": "egg fer te djärå witherbįeraunggel",
  "item.minecraft.wolf_spawn_egg": "egg fer te djärå warger",
  "item.minecraft.zoglin_spawn_egg": "skapelseegg fer zoglin",
  "item.minecraft.zombie_spawn_egg": "egg fer te djärå sombier",
  "item.minecraft.zombie_horse_spawn_egg": "egg fer te djärå sombiester",
  "item.minecraft.zombie_villager_spawn_egg": "egg fer te djärå sombibyskaller",
  "item.minecraft.zombified_piglin_spawn_egg": "skapelseegg fer sombifiirað piglin",
  "item.minecraft.experience_bottle": "fertryllninggsputell",
  "item.minecraft.fire_charge": "jäldleðningg",
  "item.minecraft.writable_book": "buok og fjäðerpenn",
  "item.minecraft.written_book": "skrievað buok",
  "item.minecraft.emerald": "smaragd",
  "item.minecraft.item_frame": "ram að grejum",
  "block.minecraft.flower_pot": "bljommkruk",
  "item.minecraft.carrot": "mųoruot",
  "item.minecraft.potato": "pära",
  "item.minecraft.baked_potato": "båkåðpära",
  "item.minecraft.poisonous_potato": "djiftugpära",
  "item.minecraft.map": "tuomkart",
  "item.minecraft.golden_carrot": "gullmųoruot",
  "block.minecraft.skeleton_skull": "skelettskoll",
  "block.minecraft.wither_skeleton_skull": "wither bįeraunggelskoll",
  "block.minecraft.player_head": "spilerovuð",
  "block.minecraft.zombie_head": "sombiovuð",
  "block.minecraft.creeper_head": "creeper-ovuð",
  "block.minecraft.dragon_head": "drakovuð",
  "item.minecraft.carrot_on_a_stick": "mųoruot ą̊ ien pinne",
  "item.minecraft.warped_fungus_on_a_stick": "fevrenggd sopp ǫ ienum pinne",
  "item.minecraft.nether_star": "netherstienna",
  "item.minecraft.pumpkin_pie": "pumpapaj",
  "item.minecraft.firework_rocket": "fyrwerkeriraktiet",
  "item.minecraft.firework_star": "fyrwerkeristienn",
  "item.minecraft.enchanted_book": "fertryllaðbuok",
  "item.minecraft.nether_brick": "nethertigelstie",
  "item.minecraft.quartz": "niðerkwarts",
  "item.minecraft.tnt_minecart": "gruvvanging min tnt",
  "item.minecraft.hopper_minecart": "gruvvangin min tratt",
  "item.minecraft.prismarine_shard": "prismarinstjyrvel",
  "item.minecraft.prismarine_crystals": "prismarinkristaller",
  "item.minecraft.rabbit": "rå eri",
  "item.minecraft.cooked_rabbit": "kuokað eri",
  "item.minecraft.rabbit_stew": "eråstuvningg",
  "item.minecraft.rabbit_foot": "eråtass",
  "item.minecraft.rabbit_hide": "eråstjinn",
  "item.minecraft.armor_stand": "rustningsstellningg",
  "item.minecraft.iron_horse_armor": "iennestrustningg",
  "item.minecraft.golden_horse_armor": "gullestrustningg",
  "item.minecraft.diamond_horse_armor": "diamantestrustningg",
  "item.minecraft.leather_horse_armor": "leðerestrustningg",
  "item.minecraft.lead": "band",
  "item.minecraft.name_tag": "namnstşylt",
  "item.minecraft.command_block_minecart": "gruvvangin min kommandoblokk",
  "item.minecraft.mutton": "råtakktjyöt",
  "item.minecraft.cooked_mutton": "kuokaðtakktyöt",
  "block.minecraft.white_banner": "wait fana",
  "block.minecraft.orange_banner": "guolroð fana",
  "block.minecraft.magenta_banner": "liuoslila fana",
  "block.minecraft.light_blue_banner": "liuosblå fana",
  "block.minecraft.yellow_banner": "guol fana",
  "block.minecraft.lime_banner": "limegryön fana",
  "block.minecraft.pink_banner": "stjär fana",
  "block.minecraft.gray_banner": "grå fana",
  "block.minecraft.light_gray_banner": "liuosgrå fana",
  "block.minecraft.cyan_banner": "syanfergað fana",
  "block.minecraft.purple_banner": "lila fana",
  "block.minecraft.blue_banner": "blå fana",
  "block.minecraft.brown_banner": "brun fana",
  "block.minecraft.green_banner": "gryön fana",
  "block.minecraft.red_banner": "roð fana",
  "block.minecraft.black_banner": "swart fana",
  "item.minecraft.end_crystal": "endkristall",
  "item.minecraft.chorus_fruit": "körfrukt",
  "item.minecraft.popped_chorus_fruit": "autslaiðn körfrukt",
  "item.minecraft.beetroot": "roðbiet",
  "item.minecraft.beetroot_seeds": "roðbietfrie",
  "item.minecraft.beetroot_soup": "roðbietssuoð",
  "item.minecraft.dragon_breath": "drakande",
  "item.minecraft.splash_potion": "skwekkend drykk eð går it djärå□ingg effekter",
  "item.minecraft.spectral_arrow": "spektralkuov",
  "item.minecraft.tipped_arrow": "weltaðkuov so gor it djärå□ingg effekter",
  "item.minecraft.lingering_potion": "langgsam drykk eð går it djärå□ingg effekter",
  "item.minecraft.shield": "stjöld",
  "item.minecraft.elytra": "elytra",
  "item.minecraft.spruce_boat": "grǫbåt",
  "item.minecraft.birch_boat": "byörkbåt",
  "item.minecraft.jungle_boat": "junggelbåt",
  "item.minecraft.acacia_boat": "akasiabåt",
  "item.minecraft.dark_oak_boat": "mörkiekbåt",
  "item.minecraft.totem_of_undying": "uoðoð-totem",
  "item.minecraft.shulker_shell": "shulkerskal",
  "item.minecraft.iron_nugget": "iennkluns",
  "item.minecraft.knowledge_book": "kunnskapsbuok",
  "item.minecraft.debug_stick": "lausstor",
  "item.minecraft.music_disc_13": "musikstjiv□c418 - 13",
  "item.minecraft.music_disc_cat": "musikstjiv□c418 - cat",
  "item.minecraft.music_disc_blocks": "musikstjiv□c418 - block",
  "item.minecraft.music_disc_chirp": "musikstjiv□c418 - chirp",
  "item.minecraft.music_disc_far": "musikstjiv□c418 - far",
  "item.minecraft.music_disc_mall": "musikstjiv□c418 - mall",
  "item.minecraft.music_disc_mellohi": "musikstjiv□c418 - mellohi",
  "item.minecraft.music_disc_stal": "musikstjiv□c418 - stal",
  "item.minecraft.music_disc_strad": "musikstjiv□c418 - strad",
  "item.minecraft.music_disc_ward": "musikstjiv□c418 - ward",
  "item.minecraft.music_disc_11": "musikstjiv□c418 - 11",
  "item.minecraft.music_disc_wait": "musikstjiv□c418 - wait",
  "item.minecraft.music_disc_pigstep": "musikstjiv□lena raine - pigstep",
  "item.minecraft.trident": "liuoster□□bar ðu ar i nevån du bruker mjäst ov:□+8 atakkskåðå□-2.9 atakkfart",
  "item.minecraft.phantom_membrane": "skromtinna",
  "item.minecraft.nautilus_shell": "nautilusskal",
  "item.minecraft.heart_of_the_sea": "sjujärta",
  "item.minecraft.crossbow": "armbuost",
  "item.minecraft.suspicious_stew": "misstainkt stuvningg",
  "block.minecraft.loom": "wevstuolur",
  "item.minecraft.flower_banner_pattern": "fanmömster□bliuomleðningg",
  "item.minecraft.creeper_banner_pattern": "fanmömster□creeper-leðningg",
  "item.minecraft.skull_banner_pattern": "fanmömster□skoll-leðningg",
  "item.minecraft.mojang_banner_pattern": "fanmömster□gräj",
  "item.minecraft.globe_banner_pattern": "fanmömster□glob",
  "item.minecraft.piglin_banner_pattern": "fanmömster□snauta",
  "block.minecraft.composter": "suopendyndj",
  "block.minecraft.barrel": "tunna",
  "block.minecraft.smoker": "rätjungen",
  "block.minecraft.blast_furnace": "blästungen",
  "block.minecraft.cartography_table": "kartriterbuord",
  "block.minecraft.fletching_table": "fletchinbuord",
  "block.minecraft.grindstone": "slipstie",
  "block.minecraft.lectern": "kateðer",
  "block.minecraft.smithing_table": "smiðbuord",
  "block.minecraft.stonecutter": "stiestjärer",
  "block.minecraft.bell": "rindjklukk",
  "block.minecraft.lantern": "lykta",
  "block.minecraft.soul_lantern": "själsllykta",
  "item.minecraft.sweet_berries": "syötu ber",
  "block.minecraft.campfire": "sovujäld",
  "block.minecraft.soul_campfire": "själsjäldn",
  "block.minecraft.shroomlight": "shroomliuos",
  "item.minecraft.honeycomb": "wakskaku",
  "block.minecraft.bee_nest": "bisamell",
  "block.minecraft.beehive": "bikup",
  "item.minecraft.honey_bottle": "onunggsputell",
  "block.minecraft.honey_block": "onunggsblokk",
  "block.minecraft.honeycomb_block": "wakskakublokk",
  "block.minecraft.lodestone": "magnetit",
  "block.minecraft.netherite_block": "blokk ov netherite",
  "block.minecraft.ancient_debris": "ljuotgåmålt rappel",
  "block.minecraft.target": "mǫl",
  "block.minecraft.crying_obsidian": "grainend obsidian",
  "block.minecraft.blackstone": "swartstien",
  "block.minecraft.blackstone_slab": "swartstįestjiv",
  "block.minecraft.blackstone_stairs": "swartstįetrampur",
  "block.minecraft.gilded_blackstone": "gullsmitåð swartstien",
  "block.minecraft.polished_blackstone": "polirað swartstien",
  "block.minecraft.polished_blackstone_slab": "polirað stjiv ov swartstien",
  "block.minecraft.polished_blackstone_stairs": "polirað trampur ov swartstien",
  "block.minecraft.chiseled_polished_blackstone": "mejslad polirað swartstien",
  "block.minecraft.polished_blackstone_bricks": "poliraðer swartstįestiener",
  "block.minecraft.polished_blackstone_brick_slab": "stjiv ov polirað swartstįestiener",
  "block.minecraft.polished_blackstone_brick_stairs": "trampur ov polirað swartstįestiener",
  "block.minecraft.cracked_polished_blackstone_bricks": "sprukkner swartstįestiener",
  "block.minecraft.respawn_anchor": "anker för återupplivningg",
}
export const ovd = items; 
